import React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchWithToken } from '../network';

const logout = async () => {
  localStorage.removeItem('dfast_val');

  // do not await
  fetchWithToken('rest-auth/logout/', { method: 'POST' });

  window.location.reload();
};

class Nav extends React.Component {
  render() {
    let username;
    if (this.props.user) {
      username = this.props.user.username;
    }

    return (
      <Menu mode="horizontal" defaultOpenKeys={['optimizer']}>
        <Menu.Item key="optimizer">
          <Link to="/">Optimizer</Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/about">About</Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/research">Research</Link>
        </Menu.Item>

        {!username && (
          <Menu.Item style={{ float: 'right', marginRight: 24 }}>
            <Link to="/login">Login</Link>
          </Menu.Item>
        )}
        {!username && (
          <Menu.Item style={{ float: 'right', marginRight: 24 }}>
            <Link to="/sign-up">Sign Up</Link>
          </Menu.Item>
        )}

        {username && (
          <Menu.Item style={{ float: 'right', marginRight: 24 }}>
            <Link to="/profile">{username}</Link>
          </Menu.Item>
        )}
        {username && (
          <Menu.Item style={{ float: 'right', marginRight: 24 }}>
            <Link to="/" onClick={() => logout()}>
              Log Out
            </Link>
          </Menu.Item>
        )}
      </Menu>
    );
  }
}

export default connect(store => store)(Nav);



// WEBPACK FOOTER //
// ./src/components/Nav.js